var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"stroke":"currentColor","stroke-width":"2","fill":"none"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M12 19l9 2-9-18-9 18 9-2zm0 0v-8"}})])}
var staticRenderFns = []

export { render, staticRenderFns }